<div *ngIf="hasNicknameOption" class="sloa-nickname-cell">
  <span
    *ngIf="showNicknameWithEdit"
    id="nickname-edit"
    data-testid="nickname-edit"
    >{{ nickNameInContext
    }}<sdps-icon
      data-testid="edit-icon"
      class="edit-icon"
      color="active"
      type="functional"
      name="edit"
      size="small"
      (click)="onEditClicked()"
    ></sdps-icon
  ></span>
  <span
    id="add-nickname"
    data-testid="add-nickname"
    *ngIf="showAddNicknameOption"
    class="add-nickname"
    (click)="onAddNickname()"
    >Add nickname</span
  >

  <div *ngIf="editClicked || addNickNameClicked">
    <form
      id="nickname-form"
      data-testid="nickname-form"
      class="sloa-nickname-form"
      [formGroup]="sloaNickNameForm"
    >
      <input
        #nicknameInput
        id="nickname-input"
        data-testid="nickname-input"
        type="text"
        maxlength="50"
        formControlName="nickname"
        (keydown.control.a)="selectAll(nicknameInput)"
        (keydown)="validationService.validateNumberInput($event, nicknameAllowedCharacters)"
        (keydown.enter)="onSubmit()"
        (blur)="onInput(nicknameInput)"
        (input)="onInput(nicknameInput)"
        (keydown.arrowleft)="$event.stopPropagation()"
        (keydown.arrowright)="$event.stopPropagation()"
      />
      <sdps-icon
        id="submit-icon"
        data-testid="submit-icon"
        class="submit-icon"
        color="primary"
        type="functional"
        name="success"
        size="medium"
        (mousedown)="onMouseDown($event)"
        (click)="onSubmit()"
      ></sdps-icon>
      <sdps-icon
        id="cancel-icon"
        data-testid="cancel-icon"
        class="cancel-icon"
        color="primary"
        type="functional"
        name="close"
        size="medium"
        (mousedown)="onMouseDown($event)"
        (click)="onCancel()"
      ></sdps-icon>
    </form>
  </div>
</div>
